export default {
  currency: {
    style: 'currency',
    currency: 'USD'
  },
  app: {
    signin: 'Entrar',
    signup: 'Cadastrar-se',
    or: 'ou',
    save: 'Salvar',
    yes: 'Sim',
    no: 'Não',
    clickHere: 'Clique aqui',
    back: 'Voltar',
    info: {
      noResults: 'Sua busca não retornou nenhum resultado',
      noMoreResults: 'Não há mais resultados'
    },
    delete: 'Excluir',
    loading: 'Carregando',
    discover: 'Descobrir',
    shop: 'Loja',
    360: '360',
    latestNews: 'Últimas notícias',
    featuredPlaylist: {
      title: 'Playlist em destaque',
      createdBy: 'Criado por'
    },
    recommended: 'Recomendado por BeatHey',
    leaveConfirmation: 'Tem certeza de que deseja sair do site? As informações inseridas serão perdidas',
    notAllowed: 'Sua conta não tem permissão para realizar esta ação.',
    notShowAgain: 'Aceitar'
  },

  form: {
    message: 'Mensagem',
    send: 'Enviar'
  },

  provider: {
    directLink: 'Criar acesso à tela inicial'
  },

  discover: {
    carousels: {
      artists: 'ARTISTAS',
      tracks: 'AS ÚLTIMAS',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'PLAYLISTS RECOMENDADAS'
    }
  },

  error: {
    emailRequired: 'E-mail é obrigatório',
    emailInvalid: 'E-mail é inválido',
    emailRepeated: 'E-mail já existe',
    confirmEmailRequired: 'Confirmação de e-mail é obrigatória',
    confirmEmailInvalid: 'Os dois e-mails não coincidem',
    valueRequired: 'Valor é obrigatório',
    valueInvalid: 'Valor deve ser um número',
    valueMinPrice: 'O valor deve ser maior ou igual a: ',
    voucherInvalid: 'Voucher inexistente, tente outro',
    voucherInactive: 'Voucher não está mais ativo',
    voucherFulled: 'Voucher esgotado',
    shortVoucher: 'O voucher deve ter mais de 10 caracteres',
    longVoucher: 'O voucher deve ter menos de 10 caracteres',
    trackNameRequired: 'Nome da faixa é obrigatório',
    iswcErrorCode: 'O código ISWC deve respeitar o formato T-xxxxxxxxx-x',
    genreRequired: 'Gênero da faixa é obrigatório',
    usernameRequired: 'Nome de usuário é obrigatório',
    usernameRepeated: 'Nome de usuário já existe',
    idRequired: 'ID é obrigatório',
    shortId: 'ID muito curto',
    phoneInvalid: 'Telefone é inválido',
    addressRequired: 'Endereço é obrigatório',
    birthdateRequired: 'Data de nascimento é obrigatória',
    confirmPasswordInvalid: 'As senhas não coincidem',
    passwordRequired: 'Senha é obrigatória',
    nameRequired: 'Nome é obrigatório',
    messageRequired: 'Mensagem é obrigatória',
    messageMaxLength: 'A mensagem é muito longa. O número máximo de caracteres é 2048',
    playlistRequired: 'Você deve selecionar uma playlist',
    playlistNameRequired: 'Nome da playlist é obrigatório',
    trackUpload: 'Ocorreu um erro ao salvar a faixa',
    pictureRequired: 'Imagem é obrigatória',
    minPriceRequired: 'Este campo é obrigatório',
    minPriceValue: 'O valor não pode ser inferior a 1 USD',
    albumNameRequired: 'Você deve inserir um nome para o álbum',
    trackFileRequired: 'Você deve carregar uma faixa',
    albumUpload: 'Falha ao salvar o álbum',
    store: {
      network: 'Erro de rede',
      userValidation: 'Ocorreu um erro ao validar o usuário',
      paymentLink: 'Houve um erro ao obter o link de pagamento',
      myFavorites: 'Ocorreu um erro ao carregar meus favoritos',
      myTracks: 'Ocorreu um erro ao carregar minhas faixas',
      myPlaylists: 'Ocorreu um erro ao carregar minhas playlists',
      voteValidation: 'Ocorreu um erro ao verificar seus votos',
      data: 'Ocorreu um erro ao carregar os dados',
      artists: 'Ocorreu um erro ao carregar artistas',
      playlists: 'Ocorreu um erro ao carregar playlists',
      tracks: 'Ocorreu um erro ao carregar faixas',
      voteQuote: 'Você já votou em 3 artistas! No próximo mês você terá 3 novos votos para continuar votando',
      SameArtistAndUser: 'Você não pode votar em si mesmo',
      vote: 'Ocorreu um erro ao votar em um artista',
      vinylContest: 'Ocorreu um erro ao carregar o concurso de vinil',
      contact: 'Ocorreu um erro ao enviar a mensagem',
      addToPlaylist: 'Ocorreu um erro ao adicionar uma faixa à playlist',
      newPlaylist: 'Houve um erro ao criar a playlist',
      deletePlaylist: 'Houve um erro ao deletar a playlist',
      updatePlaylist: 'Houve um erro ao editar a playlist',
      deleteFromPlaylist: 'Houve um erro ao excluir a faixa da playlist',
      deleteTrack: 'Houve um erro ao deletar a faixa',
      noDataPosted: 'Erro: dados faltando',
      authenticationFailed: 'O e-mail ou senha estão incorretos',
      login: 'Ocorreu um erro ao fazer login',
      playlist: 'Ocorreu um erro ao carregar a playlist',
      playlistPrivate: 'Erro: playlist privada',
      playlistNotFound: 'Erro: playlist não encontrada',
      featuredPlaylist: 'Ocorreu um erro ao carregar a playlist em destaque',
      artistNotFound: 'Erro: artista não encontrado',
      notSaved: 'Erro: alterações não salvas',
      editArtist: 'Erro ao atualizar dados do artista',
      notValidToken: 'Erro de autenticação',
      track: 'Ocorreu um erro ao carregar a faixa',
      likePlaylist: 'Ocorreu um erro ao curtir a playlist'
    }
  },

  users: {
    login: 'Entrar',
    username: 'Nome de usuário',
    name: 'Nome | Nomes',
    surnames: 'Sobrenomes',
    id: 'ID',
    email: 'E-mail',
    emailConfirmation: 'Confirmar e-mail',
    address: 'Endereço',
    password: 'Senha',
    phone: 'Telefone',
    birthdate: 'Data de nascimento',
    day: 'Dia',
    month: 'Mês',
    year: 'Ano',
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro',
      'Novembro', 'Dezembro'
    ],
    code: 'Código',
    voucher: 'Insira o código de desconto',
    generateReferralCode: 'Gerar código de indicação',
    choseUserType: 'Escolha seu perfil',
    textUserType: 'Esta opção pode ser alterada em "Meu Perfil"',
    userType: {
      musicFan: 'Fã',
      producer: 'Artista',
      free: 'Ouvinte',
      flowArtist: {
        artisticName: 'Nome artístico',
        text: 'Você pode alterar todas as suas informações pessoais e artísticas em "Meu Perfil"'
      }
    },
    registration: {
      shareData: 'Compartilhar meus dados de registro com os provedores de conteúdo do BEATHEY para fins de marketing.',
      accept: 'Ao clicar em REGISTRAR, você aceita',
      comma: ', o',
      andThe: 'e o',
      register: 'Registrar',
      alreadyHaveAnAccount: 'Já tem uma conta?'
    },
    accept: {
      newsLetter: 'Aceito receber Newsletter',
      shareInfo: 'Aceito compartilhar informações de contato com Artistas'
    },
    bio: 'Bio',
    bioDescription: 'Escreva algo sobre você que te represente',
    country: 'País',
    city: 'Cidade',
    forgetPassword: {
      question: 'Esqueceu sua senha?',
      success: 'Uma nova senha foi enviada para o e-mail',
      button: 'Enviar'
    },
    rememberPassword: 'Lembrou sua senha?',
    changePassword: 'Alterar senha',
    passwordConfirmation: 'Confirmar senha',
    hasNotFavorites: 'Você não adicionou uma faixa aos seus favoritos',
    editSuccess: 'As informações foram atualizadas corretamente',
    loginToUnauthorizedUser: 'Para continuar ouvindo música, convidamos você a se registrar',
    cancelLoginToUnauthorizedUser: 'Cancelar',
    subscription: {
      title: 'Assine!',
      info1: 'Vinil como presente com os 4 melhores artistas de cada Concurso de Vinil (Somente para a Argentina)',
      info2: 'Receba a revista BeatHey como presente (Somente para a Argentina)',
      info3: 'Se você é um artista, tem a possibilidade de publicar sua música e ser votado no Concurso de Vinil',
      info4: 'Se você é um artista, 100% da arrecadação das vendas de músicas é sua.',
      info5: 'Se você é um artista, pode ser selecionado para tocar em eventos BeatHey',
      info6: 'Formas de pagamento',
      infoEmailNeeded1: 'Por regulamentações internas do MercadoPago, precisamos do endereço de e-mail associado à carteira (MercadoPago) com a qual realizaremos a transação',
      infoEmailNeeded2: 'Essas informações não serão armazenadas pela BeatHey e são de uso exclusivo para esta operação.',
      valueTitle: 'Seja parte da comunidade por',
      currency: 'USD',
      value: '3',
      free: 'Grátis!!',
      button: 'Assinar',
      cancel: 'Cancelar',
      disaffiliate: 'Desafiliar-se',
      confirm: 'Confirmar',
      reject: 'Rejeitar',
      cancelTitle: 'Obrigado por nos escolher!',
      cancelMessage: 'Você tem certeza de que deseja cancelar sua assinatura do BeatHey?',
      cancelAccountMessage: 'Você tem certeza de que deseja cancelar sua conta do BeatHey?',
      cancelAccount: 'Cancelar sua conta do BeatHey.',
      cancelAccountSuccess: 'Sua conta do BeatHey foi deletada com sucesso.',
      cancelAccountError: 'Houve um problema ao deletar sua conta.',
      cancelSubscription: 'Desafiliar sua assinatura recorrente do BeatHey.',
      canceledMPsubSuccess: 'Sua assinatura recorrente através do Mercado Pago foi cancelada com sucesso',
      canceledMPsubError: 'Sua assinatura recorrente através do Mercado Pago já foi cancelada',
      voucherCodeMsg: 'Insira o código de benefícios',
      referredCodeMsg: 'Insira o código de indicação',
      sendEmailNeeded: 'Para processar'
    },

    payment: {
      message: 'Escolha um método de pagamento'
    },
    userMenu: {
      myProfile: 'Perfil',
      myTracks: 'Minhas Faixas',
      myPlaylists: 'Minhas Playlists',
      myFavorites: 'Meus Favoritos',
      myShopping: 'Minhas Compras',
      myAccount: 'Minha Conta',
      help: 'Ajuda',
      terms: 'Termos e Condições',
      logout: 'Sair'
    },
    followArtist: 'Agora você segue',
    unfollowArtist: 'Você parou de seguir',
    follow: 'Seguir',
    following: 'Seguindo',
    copyCodeSucces: 'O código foi copiado corretamente',
    copyLinkSucces: 'O link foi copiado corretamente',
    copyError: 'Ocorreu um erro ao copiar'
  },

  artists: {
    seeAll: 'Ver tudo',
    artists: 'Artistas',
    artist: 'Artista | Artistas',
    search: {
      placeholder: 'Pesquisar por nome...',
      noMoreResults: 'Não há mais resultados'
    },
    info: 'Informações do artista',
    name: 'Nome',
    phrase: 'Descendência',
    text: 'Informações',
    hasNotTracks: 'O artista não tem nenhuma faixa',
    hasNotPlaylists: 'O artista não tem nenhuma playlist',
    hasNotInfo: 'O artista não tem informações',
    section: {
      info: 'Informações',
      contact: 'Contato'
    },
    contact: {
      'messagePlaceholder': 'Escreva sua mensagem aqui',
      'success': 'A mensagem foi enviada corretamente'
    }
  },

  albums: {
    uploadAlbum: 'Carregar Álbum',
    newAlbum: {
      warningMessage: 'Preencha os detalhes do álbum para acessar o carregamento de faixas',
      namePlaceholder: 'Nome do álbum',
      uploaded: 'O álbum foi criado com sucesso',
      selectFiles: 'Selecionar arquivos',
      uploadButton: 'Carregar Álbum',
      tagsPlaceholder: 'Descreva os membros que participaram do desenvolvimento da obra. Ex: PRODUTOR, MIXAGEM E MASTERIZAÇÃO, CAPA, etc.'
    }
  },

  tracks: {
    seeAll: 'Ver tudo',
    uploadTrack: 'Carregar Faixa',
    track: 'Sem faixas | faixa | faixas',
    title: 'Título',
    artist: 'Artista',
    genre: 'Gênero',
    genres: {
      all: 'Todos'
    },
    minPrice: 'Preço mínimo em U$D',
    release: 'Data',
    actions: {
      like: 'Curtir',
      addToQueue: 'Adicionar à fila',
      buy: 'Comprar',
      share: 'Compartilhar',
      addToPlaylist: 'Adicionar à playlist',
      deleteFromPlaylist: 'Excluir da playlist',
      edit: 'Editar'
    },
    buyTrack: {
      title: 'Ajude o ',
      line1: 'Ao baixar a faixa, você ajuda o artista a continuar trabalhando em sua música.',
      line2: 'Você decide quanto valoriza a música dele.',
      downloadMessage: 'Você encontrará o link de download da faixa na seção "Minhas Compras" do Perfil.',
      valueLabel: 'Valor',
      button: 'Comprar'
    },
    newTrack: {
      button: 'Carregar Conteúdo',
      newRelease: 'Adicionar à lista de NOVO LANÇAMENTO',
      dropSelectTrack: 'Solte ou selecione o arquivo',
      selectFile: 'Selecionar arquivo',
      dropMessage: 'Solte o arquivo para carregar',
      important: 'Importante: ',
      info: 'Ao compartilhar, você confirma que seus sons estão em conformidade com nossos termos de uso e não infringem os direitos de qualquer outra pessoa. Em caso de dúvida, consulte nossas páginas e FAQ sobre direitos autorais antes de carregar.',
      question1: 'Problemas ao carregar arquivos?',
      answer1: 'Veja nossas dicas de solução de problemas.',
      question2: 'Que tipos de arquivos posso carregar?',
      answer2: 'Você pode carregar MP3s. O tamanho máximo do arquivo é 50MB.',
      extensionMessage: 'O arquivo deve ser mp3',
      leaveConfirmation: 'Tem certeza de que deseja sair do site? A faixa não foi salva',
      notProducer: 'Para carregar faixas, você deve se inscrever como DJ/Produtor!',
      uploaded: 'A faixa foi carregada corretamente',
      imageError: 'A imagem selecionada excede as dimensões esperadas, deve ser inferior a 4024 x 3768 pixels',
      imageType: 'O arquivo deve ser uma imagem (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Compartilhe sua música',
      selectPicture: 'Selecionar imagem da faixa',
      completed: 'Carregamento completo',
      namePlaceholder: 'Nome da faixa',
      tagsPlaceholder: 'Descreva em palavras o estilo da sua faixa',
      recommendedPlaceHolder: 'Diga-nos qual é o seu gênero musical! Ajude-nos a expandir a família BeatHey.',
      uploaded: 'A faixa foi carregada corretamente',
      iswcCode: 'Código ISWC Ex: T-xxxxxxxxx-x (opcional)',
      saveChanges: 'Salvar Alterações',
      listUploaded: 'A lista foi atualizada com sucesso'
    },
    deleteTrack: {
      title: 'Excluir faixa',
      success: 'A faixa foi excluída',
      confirm: 'Tem certeza de que deseja excluir a faixa?'
    },
    shareTrack: {
      title: 'Compartilhar faixa',
      copy: 'Copiar',
      success: 'O link foi copiado corretamente',
      error: 'Ocorreu um erro ao copiar o link'
    },
    licenses: {
      features: 'Recursos das licenças',
      selected: 'Licença escolhida',
      questions: {
        1: {
          title: 'Você quer permitir que adaptações de seu trabalho sejam compartilhadas?',
          options: {
            1: 'Sim',
            2: 'Não',
            3: 'Sim, desde que seja compartilhado da mesma forma'
          }
        },
        2: {
          title: 'Você quer permitir o uso comercial de seu trabalho?',
          options: {
            1: 'Sim',
            2: 'Não'
          }
        }
      }
    },
    headers: {
      title: 'Título',
      artist: 'Artista',
      genre: 'Gênero',
      released: 'Lançado',
      duration: 'Duração',
      date: 'Comprado'
    }
  },

  playlists: {
    seeAll: 'Ver tudo',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Público',
      private: 'Privado'
    },
    isPrivate: 'Esta playlist é privada',
    addToPlaylist: {
      title: 'Adicionar à playlist',
      select: 'Selecione uma playlist',
      add: 'Adicionar',
      success: 'A faixa foi adicionada à playlist corretamente',
      trackAlreadyExist: 'A faixa já existe nesta playlist'
    },
    newPlaylist: {
      button: 'Nova playlist',
      title: 'Nova playlist',
      imageError: 'Ocorreu um erro ao carregar a imagem da playlist',
      playlistName: 'Título da playlist',
      saveAndAdd: 'Salvar e adicionar',
      success: 'A playlist foi criada corretamente'
    },
    delete: {
      confirm: 'Tem certeza de que deseja excluir a playlist?',
      success: 'A playlist foi excluída corretamente',
      title: 'Excluir Playlist'
    },
    edit: {
      title: 'Editar playlist',
      button: 'Editar',
      success: 'A playlist foi atualizada corretamente'
    },
    deleteTrackFromPlaylist: {
      'title': 'Excluir faixa da playlist',
      'success': 'A faixa foi excluída da playlist corretamente',
      'confirm': 'Tem certeza de que deseja excluir a faixa da playlist?'
    },
    sharePlaylist: 'Compartilhar playlist',
    like: {
      button: 'curtir'
    }
  },

  vinylContest: {
    noArtist: 'Nenhum artista foi votado ainda',
    vote: 'Votar',
    success: 'Seu voto foi registrado!',
    link: 'Ir para o Concurso',
    title: 'Concurso',
    closeIn: 'Fechar em:',
    day: 'dia | dias',
    hour: 'hora | horas',
    minute: 'minuto | minutos'
  },

  payment: {
    mpConnect: {
      info: 'Conecte-se ao Mercado Pago para receber 100% das vendas de suas faixas, sem intermediários, diretamente em sua conta pessoal.',
      title: 'Receba a venda de suas faixas através do Mercado Pago!',
      connectedAs: 'Conectado como',
      disconnectInfo: 'Para desconectar sua conta, entre em ',
      nickname_title_help: 'Estas informações estão visíveis para o comprador no processo de checkout. Recomendamos escolher um nome relacionado ao artista.'
    },
    connect: 'Conectar',
    paypal: {
      'subscriptionSuccess': 'Sua assinatura foi gerada com sucesso'
    }
  },

  help: {
    title: 'Como podemos ajudar?',
    contactInformation: 'Informações de contato',
    whatsapp: '+54 911 5574 0051',
    email: 'contato@beathey.com',
    contactForm: {
      title: 'Envie-nos sua pergunta',
      success: 'A mensagem foi enviada corretamente'
    },
    unsubscribe: 'Lembre-se, para cancelar a inscrição com ',
    send: 'enviar ',
    to: 'para ',
    faqs: 'Perguntas frequentes (FAQs)'
  },

  uploadPicture: {
    selectPicture: 'Selecionar imagem'
  },

  footer: {
    terms: 'Termos e condições',
    termsOfUse: 'Termos e condições de uso',
    intellectuallyProp: 'Política de propriedade intelectual',
    privacyPolicy: 'Política de privacidade e cookies',
    help: 'Ajuda',
    contact: 'Contato',
    company: 'Empresa',
    language: {
      title: 'Idioma',
      spanish: 'Espanhol',
      english: 'Inglês',
      portuguese: 'Português'
    }
  },

  ads: {
    advertisingSpace: 'Espaço publicitário'
  },

  landing: {
    plans: 'Planos',
    music: 'Música',
    title: 'sem intermediários',
    subtitle: 'Mais perto do seu público, mais perto do seu artista',
    leyend: 'COMECE A MUDAR VIDAS',
    button1: 'Ouvindo',
    button2: 'Criando',
    join: 'Junte-se!',
    joinText: 'Conheça nosso',
    description: {
      t1: 'Renda',
      t2: 'é 100%',
      t3: 'para o artista'
    },
    oyendo: {
      title: 'Não apenas ouvindo',
      carousel: {
        text1: 'Você apoia, ajuda e constrói comunidade ao ouvir, compartilhar, comprar e votar.',
        text2: 'Somos uma comunidade de artistas independentes, e seu apoio vai diretamente para cada um de nós, sem intermediários.',
        text3: 'Estamos desenvolvendo um novo conceito na indústria musical e queremos que você faça parte disso.'
      },
      button: 'Planos'
    },
    creando: {
      title: 'Incubando talentos',
      carousel: {
        text1: 'Seu esforço é monetizado, quanto mais ouvem você, mais votam em você, mais sua música vende, mais exposição você terá.',
        text2: 'Você é dono de seus direitos, venda sua música sem intermediários, obtenha votos da comunidade no concurso trimestral e faça parte de nossa revista.',
        text3: 'Somos uma comunidade de artistas independentes, criando um novo conceito na indústria musical onde somos os protagonistas. Viva essa experiência conosco!'
      },
      button: 'Planos'
    },
    planes: {
      title: 'Sua assinatura gera mudança.',
      leyend: 'A receita das assinaturas é distribuída para os artistas sob o conceito de "pago por reprodução". Assim, sua assinatura impacta diretamente os artistas, gerando mais oportunidades para eles.',
      free: {
        text1: 'Ouça Música',
        text2: 'Publicidade Inerente ao BeatHey',
        text3: 'Compre Música'
      },
      fan: {
        text1: 'Salvar Favoritos',
        text2: 'Votar no Concurso',
        text3: 'Ouça sem Anúncios',
        text4: 'Lançamentos Digitais gratuitos dos vencedores do concurso',
        text5: 'Revista BeatHey, física e/ou digital, gratuita',
        text6: 'Descontos de até 60% nos ingressos para festivais BeatHey'
      },
      artist: {
        header: 'Todos os benefícios do Fã e mais...',
        text1: 'Carregue música e monetize-a',
        text2: 'Receba o dobro de receita por reprodução (pago por stream)',
        text3: 'Possibilidade de apresentações em festivais BeatHey com a chancela da equipe curatorial.'
      }
    }
  },

  dashboard: {
    title: 'Painel de Controle',
    atention: 'Atenção...',
    apply: 'Aplicar',
    upload: 'Músicas Carregadas',
    daysWithoutUpload: 'Dias sem Carregar',
    avg: 'Média de músicas Carregadas',
    likes: 'Curtidas',
    followers: 'Seguidores',
    reproductionsRanking: 'Ranking de Reproduções',
    songRanking: 'Detalhe das Reproduções',
    trackName: 'Nome da Faixa',
    duration: 'Duração',
    warning: 'Este módulo permite que você acesse informações sobre o que acontece com suas obras e, assim, possa tomar decisões. Assine através do botão "Carregar Conteúdo" para acessar 100% das informações disponíveis.',
    tooltipAdmin: 'Você é um administrador.',
    tooltipArtist: 'Você é um artista.',
    tooltipSubscribed: 'Você está inscrito.',
    tableName: 'Nome',
    tableArtist: 'Artista',
    tableRepro: 'Reproduções',
    tableLikes: 'Curtidas'
  },

  localContent: {
    title: 'AO VIVO',
    category: 'Categoria'
  }
}



// WEBPACK FOOTER //
// ./src/translator/pt.js